// Backend API URL - make sure there's no trailing slash
const DEV_API_URL = 'http://localhost:8787/api';
const PROD_API_URL = 'https://multix-ai-api.techspawn.workers.dev/api';

// Frontend URL (used for redirects and CORS)
const DEV_FRONTEND_URL = 'http://localhost:3000';
const PROD_FRONTEND_URL = 'https://aafa569e.multix-ai-client.pages.dev';

// Determine environment
const IS_PROD = process.env.NODE_ENV === 'production';

// Export configuration values
export const API_URL = IS_PROD ? PROD_API_URL : DEV_API_URL;
export const FRONTEND_URL = IS_PROD ? PROD_FRONTEND_URL : DEV_FRONTEND_URL;
export const REQUEST_TIMEOUT = 30000; // 30 seconds

// Chart colors configuration
export const CHART_COLORS = {
  primary: '#4e73df',
  success: '#1cc88a',
  info: '#36b9cc',
  warning: '#f6c23e',
  danger: '#e74a3b',
  whatsapp: '#25D366',
  telegram: '#0088cc'
};
